export default "/images/vendor/flag-icons/flags/1x1/dm.svg?bf54e4013c41515201a845dce6fdbb07";